<div class="container">
  <div class="my-1">
    <markdown [src]="url"></markdown>
  </div>
</div>
